import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Injector, Input, NgZone, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DropdownProjectListDto, ManualEntryDto, Proddata, ProjectServiceProxy, ProjectTaskServiceProxy, TimeAndAttendanceServiceProxy, UserTaskDto } from '@shared/service-proxies/service-proxies';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { ProductivityCandle } from '../../models/productivity-candle';
import { ProductivityCandleSection } from '../../models/productivity-candle-section';
import { ActivityService } from '../../services/activity.service';
import { ProductivityBarService } from '../../services/productivity-bar.service';
import { DateTime } from 'luxon';

@Component({
    selector: "activities-productivity-bar",
    templateUrl: "./productivity-bar.component.html",
    styleUrls: ["./productivity-bar.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [ProductivityBarService],
})
export class ProductivityBarComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    // Api call subscription
    subscription: Subscription;
    protected ngUnsubscribe: Subject<void> = new Subject<void>();

    // Inputs
    @Input() userId: number;
    @Input() tenantId: number;
    @Input() passMinute: number;
    @Input() startTime: number;
    @Input() endTime: number;
    @Input() RealTime: string;
    @Output() OfflineTimeAdded = new EventEmitter<number>();
    currentTime: Date = new Date();
    currTimeMins: number;
    totMins: number;

    isInMonthOrWeekView: boolean;
    weeklyData: any;
    monthlyData: any;
    currentViewType: string = "day";
    dateToLoad: Date;

    // Outputs
    @Output() manualTimeAdded = new EventEmitter<void>();

    // Data
    productivityData: ProductivityCandle[];
    // Manual time
    manualTime: ManualEntryDto[];

    // Bottom timeline
    bucketTimeSlot: number = 1; // time slot in hours
    timelineBuckets: number;
    timelineBucketsArray: number[];

    // Blue line
    timeSegment: number; // segment minutes in one bucket
    timeSegmentsInBucket: number;
    timeSegmentArray: number[];
    isOfflineTimeSubmitted: boolean = false;

    // Session storage variable for application Wise Spent Time
    productivityBarData: any;
    isViewProductive: boolean = true;
    isViewUnProductive: boolean;
    isViewNeutral: boolean;
    isOfflineTimeApproved: boolean;
    taskDetails: any[] = [];
    jobs: any[] = [];
    SelectedTaskCategoryId:any;
    taskMenu:any[] = [];
    constructor(
        private injector: Injector,
        private zone: NgZone,
        private _projectServiceProxy: ProjectServiceProxy,
        private _projectTaskServiceProxy: ProjectTaskServiceProxy,
        private _productivityBarService: ProductivityBarService,
        private _activityService: ActivityService,
        private cdRef: ChangeDetectorRef,
        private _timeandAttendanceServiceProxy: TimeAndAttendanceServiceProxy
    ) {
        super(injector);
    }

    // Sidebar
    isSidebarOpen: boolean = false;
    sliderValue: number = 50;
    sidebarSliderRangeValues: number[] = [
        1440, // No. of minutes corresponding to 9 am on a 24 hour period ((9 - 0) * 60)
        1440, // No. of minutes corresponding to 8 pm on a 24 hour period ( (20 - 0) * 60 )
    ];
    descriptionOfAbsence: string = "";
    sidebarProjectId: number;
    selectedTaskId: number;
    taskList: UserTaskDto[];
    projectList: DropdownProjectListDto[];
    productivityType: ProductivityCandleSection;
    manualTimeIdToDelete: number;
    selectedDate = new Date();
    // Header
    title: string = "Productivity Bar";
    // loader
    isLoading: boolean = false;

    //floor
    Fproductive: number;
    Funproductive: number;
    FNetural: number;
    // Analytics
    meanProductivePercent: number = 0;
    meanUnproductivePercent: number = 0;
    meanNeutralPercent: number = 0;

    daySelectedSubscription: Subscription;
    prodPercentage: Proddata[] = []
    chartOptions = {
        legend: {
            display: false,
        },
        elements: {
            point: {
                radius: 0,
            },
        },
        layout: {
            padding: {
                bottom: -128,
                left: -158,
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                    angleLines: {
                        display: false,
                    },
                    ticks: {
                        beginAtZero: true,
                        display: false,
                    },
                },
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                    angleLines: {
                        display: false,
                    },
                    ticks: {
                        beginAtZero: true,
                        display: false,
                    },
                },
            ],
        },
    };

    ngOnInit(): void {
        this.currTimeMins = this.currentTime.getHours() * 60 + this.currentTime.getMinutes();
        this.sidebarSliderRangeValues[1] = this.currTimeMins;
        // this._timeandAttendanceServiceProxy.getProductiviyBarStartTime().subscribe(res=>{
        //     if(this.startTime !=undefined){
        //         this.LoadBar();
        //     }
        // });

       // abp.event.on("CalcaulateMeanPaercentage", (data) => this.calcaulateMeanPaercentage(this.productivityData, data));
        
        this.productivityDataPercentage();

    }
    viewProductive() {
        this.isViewProductive = true;
        this.isViewUnProductive = false;
        this.isViewNeutral = false;
    }
    viewUnProductive() {
        this.isViewProductive = false;
        this.isViewUnProductive = true;
        this.isViewNeutral = false;
    }
    viewNeutral() {
        this.isViewProductive = false;
        this.isViewUnProductive = false;
        this.isViewNeutral = true;
    }


    currTimeTotMins(): number {
        let totMins = this.currTimeMins;
        return totMins;
    }

    ngOnChanges() {
        if (this.startTime != undefined && this.startTime !== -1) {
            this.LoadBar();
        }

    }
    Check(event) {
        let t = this.sidebarSliderRangeValues[1] - this.sidebarSliderRangeValues[0];

        if (t < 5) {
            this.sidebarSliderRangeValues[1] = this.sidebarSliderRangeValues[0] + 5;
        }
        
        let SliderHandler = document.getElementsByClassName('p-slider-handle');
        let SilderRange = document.getElementsByClassName('p-slider-range');

        if (this.minSideBarRange > this.sidebarSliderRangeValues[0]) {
            this.sidebarSliderRangeValues[0] = this.minSideBarRange;
            let PerCentageForLeftSlider = (this.minSideBarRange / this.currTimeMins) * 100;
            let temp = 'left:' + PerCentageForLeftSlider + '%';
            SliderHandler[0].setAttribute('style', temp);

        }
        if (this.maxSideBarRange < this.sidebarSliderRangeValues[1]) {
            this.sidebarSliderRangeValues[1] = this.maxSideBarRange;
            let PerCentageForRightSlider = (this.maxSideBarRange / this.currTimeMins) * 100;
            let temp = 'left:' + PerCentageForRightSlider + '%';
            SliderHandler[1].setAttribute('style', temp);
        }
        let PerCentageForLeftSlider = (this.sidebarSliderRangeValues[0] / this.currTimeMins) * 100;
        let temp = 'left:' + PerCentageForLeftSlider + '%;';
        //  SilderRange[0].setAttribute('style',temp);
        let PerCentageForRightSlider = (this.sidebarSliderRangeValues[1] / this.currTimeMins) * 100;
        let width = PerCentageForRightSlider - PerCentageForLeftSlider;

        temp += 'width:' + width + '%;';
        SilderRange[0].setAttribute('style', temp);



    }
    maxSideBarRange = 0;
    minSideBarRange = 0;
    PRodSideBar() {

        this.maxSideBarRange = this.sidebarSliderRangeValues[1];
        this.minSideBarRange = this.sidebarSliderRangeValues[0];
        this.currTimeMins = this.currTimeMins < this.maxSideBarRange ? this.maxSideBarRange : this.currTimeMins;
        this.cdRef.detectChanges();
    }
    setCurrMins() {
        this.currTimeMins = 1439;
    }
    setCurrDay(val: boolean) {
        this.TimeAddedForPreviousDay = val;
    }
    LoadBar() {

        // set the time segment from @Input
        this.timeSegment = this.passMinute;

        // generate timeline buckets
        this.timelineBuckets = (this.endTime - this.startTime) / this.bucketTimeSlot;
        this.timelineBucketsArray = [...Array(this.timelineBuckets).keys()].map((r) => r + this.startTime);

        // generate time segments in a bucket
        this.timeSegmentsInBucket = (this.bucketTimeSlot * 60) / this.timeSegment;
        this.timeSegmentArray = [...Array(this.timeSegmentsInBucket * this.timelineBuckets).keys()];

        // Add empty Productivity candles to productivityData for ng-shimmer effect
        this.setBlankDataForShimmer();

        this.productivityData = undefined;

        // start loader
        this.isLoading = true;

        // set handler when monthly or weekly view selected
        this.daySelectedSubscription = this._activityService.viewSelected.subscribe((r) => {
            if (r.type === "week") {
                this.isLoading = true;
                this.currentViewType = r.type;
                this.clearAllTimeSegments();
                if (!this.weeklyData) {
                    this.setWeeklyData().then((r) => {
                        this.isLoading = false;
                    });
                } else {
                    this.currentViewType = "week";
                    this.isLoading = false;
                }
            } else if (r.type === "month") {
                if (!this.monthlyData) {
                    this.isLoading = true;
                    this.currentViewType = r.type;
                    this.clearAllTimeSegments();
                    this.setMonthlyData().then((r) => {
                        this.isLoading = false;
                    });
                } else {
                    this.currentViewType = "month";
                    this.isLoading = false;
                }
            } else if (r.type === "day") {
                // console.log("-------------------refreshing daily productivity bar data-------------------");
                this.productivityData = undefined;
                // This aborts all HTTP requests.
                this.ngUnsubscribe.next();
                // This completes the subject properlly.
                this.ngUnsubscribe.complete();
                this.selectedDate = r.date;
                this.refreshProductivityBar(r.date);
                this.currentViewType = "day";
            }
        });
        this.daySelectedSubscription.unsubscribe();
    }


    ngAfterViewInit(): void {
        this.productivityData = undefined;
        this.cdRef.detectChanges();
    }
    currentCheckDate: Date = new Date;
    refreshProductivityBar(date?: Date): void {

        this.productivityData = undefined;
        this.isLoading = true;
        this.setBlankDataForShimmer();
        this.clearAllTimeSegments();
        this.currentCheckDate = date ?? this.currentCheckDate ?? new Date();

        this.subscription = this._productivityBarService
            .getProductivityBarData(this.userId, this.tenantId, this.timeSegment, this.startTime, this.endTime, date)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((r) => {
                this.productivityData = r;
                this.manualTime = this._productivityBarService.getManualTime();
                // Populate data in chart
                setTimeout(() => {
                    this.isLoading = false;
                    this.populateData(this.productivityData || []);
                });
            });
    }

    setCandleSegmentHeights(): void {
        let candleSegments = document.querySelectorAll(".candle-segment");
        candleSegments.forEach((r) => {
            (r as HTMLElement).style.height = "100%";
        });
    }

    timeStampToSeconds(seconds: string) {
        if (!seconds) return 0;
        let arr = seconds.split(":").map((r) => parseInt(r));
        return arr[0] * 3600 + arr[1] * 60 + arr[2];
    }



    async productivityDataPercentage() {

        //let r = await this._timeandAttendanceServiceProxy.getUserWiseProductiveUnProductiveAndNuetralData(this.userId, this.tenantId).toPromise();
        //this.productivityBarData = JSON.parse(JSON.stringify(r));
        //added localStorage
        // let getUserProdUnProdData = localStorage.getItem('getUserWiseProductiveAndNuetralData');
        // this.productivityBarData = JSON.parse(getUserProdUnProdData);


    }

    callApiOneTime = true;
    populateData(productivityData: ProductivityCandle[]): void {
        // Populate candles
        this.timeSegmentArray = this.timeSegmentArray.length > productivityData.length ?
        this.timeSegmentArray.filter(x => x < productivityData.length) : [...Array(productivityData?.length).keys()];
        for (let i = 0; i < productivityData?.length; i++) {
            this.zone.runOutsideAngular(() => {
                setTimeout(() => {
                    const activeSegmentContainer = document.querySelector(`[data-time-segment-index="${i}"]`);
                    const candleSegmentContainer = document.querySelector(`[data-candle-segment-index="${i}"]`);

                    if (productivityData[i]?.isDataAvailable && !productivityData[i]?.privatePercent) {
                        activeSegmentContainer?.classList?.add("active-fill");
                        if((candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement).style.height = `${productivityData[i].productivePercent}%`;
                        if (productivityData[i].productivePercent == 0 && (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement).style.display = 'none';
                        // unproductive
                        if ((candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement).style.height = `${productivityData[i].unproductivePercent}%`;
                        if (productivityData[i].unproductivePercent == 0 && (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement).style.display = 'none';
                        // neutral
                        if ((candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement).style.height = `${productivityData[i].neutralPercent}%`;
                        if (productivityData[i].neutralPercent == 0 && (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement).style.display = 'none';
                    } else {
                        activeSegmentContainer?.classList?.remove("active-fill");
                        try {
                            if ((candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement).style.height = `0`;
                        } catch {
                        }
                        try {
                            if ((candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement).style.height = `0`;
                        } catch {
                        }
                        try {
                            if ((candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement).style.height = `0`;
                        } catch {
                        }
                        if (productivityData[i]?.privatePercent <= 0 && productivityData[i]?.isDataAvailable != true) {
                            activeSegmentContainer?.classList?.remove("active-fill-private-time");
                        }
                        else if (productivityData[i]?.privatePercent >= 0 && productivityData[i]?.isDataAvailable == true) {
                            activeSegmentContainer?.classList?.add("active-fill-private-time");

                        }
                    }
                    try {
                        if ((candleSegmentContainer as HTMLElement))
                        (candleSegmentContainer as HTMLElement).style.height = "100%";
                    } catch {

                    }

                }, 7 * i);
            });
        }
       if (!this.RealTime) this.calcaulateMeanPaercentage(productivityData, null);


    }

    calcaulateMeanPaercentage(productivityData: ProductivityCandle[] = [], productivityBarData) {
         // Calculate mean percentages
         let temp = new Date();

         if (this.currentCheckDate.getDay() == temp.getDay() && this.currentCheckDate.getMonth() == temp.getMonth() && this.currentCheckDate.getFullYear() == temp.getFullYear()) {
             if(JSON.parse(sessionStorage.getItem("applicationWiseSpentTime")) && !this.RealTime) this.productivityBarData = JSON.parse(sessionStorage.getItem("applicationWiseSpentTime"));
             if(productivityBarData && this.RealTime) this.productivityBarData = productivityBarData;
             if (this.productivityBarData == null) {
                 // this.productivityDataPercentage();
                 if (this.callApiOneTime && this.userId != undefined && this.tenantId != undefined) {
                     var date = new Date();
                     this.callApiOneTime = false;
                     this._timeandAttendanceServiceProxy.getUserWiseProductiveUnProductiveAndNuetralData(this.userId, this.tenantId, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)),date.getTimezoneOffset()).subscribe((r) => {
                         let reducedTotalArr = r.map((r) => {
                             return [
                                 this.timeStampToSeconds(r.productiveTime),
                                 this.timeStampToSeconds(r.unProductiveTime),
                                 this.timeStampToSeconds(r.nuetralTime),
                             ];
                         });
                         let totalArr = [0, 0, 0];
                         var tot = 0;
                         reducedTotalArr.forEach((r) => {
                             totalArr[0] += r[0];
                             totalArr[1] += r[1];
                             totalArr[2] += r[2];
                             tot += r[0] + r[1] + r[2];
                         });

                         let leftPieChartPercentageArray = [];
                         totalArr.map((r) => (r) / totalArr.reduce((a, v) => (a += v), 0));
                         var a = (totalArr[0] / tot) * 1;
                         leftPieChartPercentageArray.push(a);
                         a = (totalArr[1] / tot);
                         leftPieChartPercentageArray.push(a);
                         a = (totalArr[2] / tot);
                         leftPieChartPercentageArray.push(a);

                         if (totalArr[0] == 0 && totalArr[1] == 0 && totalArr[2] == 0) {

                             return;
                         }
                         leftPieChartPercentageArray = totalArr.map((r) => (r * 100) / totalArr.reduce((a, v) => (a += v), 0) / 100);

                         let val = [
                             new Proddata({
                                 id: 0,
                                 key: "productive",
                                 val: leftPieChartPercentageArray[0] * 100,
                                 val2: 0
                             })
                             ,
                             new Proddata({
                                 id: 1,
                                 key: "unproductive",
                                 val: leftPieChartPercentageArray[1] * 100,
                                 val2: 0
                             })
                             ,
                             new Proddata({
                                 id: 2,
                                 key: "Neutral",
                                 val: leftPieChartPercentageArray[2] * 100,
                                 val2: 0
                             })
                         ]

                         if (leftPieChartPercentageArray[0] != 0 || leftPieChartPercentageArray[1] != 0 || leftPieChartPercentageArray[2] != 0) {

                             this._timeandAttendanceServiceProxy.calculateProperPercentage(val).subscribe(res => {
                                 this.meanProductivePercent = res[0].val;
                                 this.meanUnproductivePercent = res[1].val;
                                 this.meanNeutralPercent = res[2].val;




                             });
                         }
                         else {
                             this.meanProductivePercent = 0;
                             this.meanUnproductivePercent = 0;
                             this.meanNeutralPercent = 0;

                         }
                     });
                 }

             }
             else {

                 let reducedTotalArr = this.productivityBarData?.map((r) => {
                     return [
                         this.timeStampToSeconds(r.productiveTime),
                         this.timeStampToSeconds(r.unProductiveTime),
                         this.timeStampToSeconds(r.nuetralTime),
                     ];
                 });
                 let totalArr = [0, 0, 0];
                 var tot = 0;
                 reducedTotalArr?.forEach((r) => {
                     totalArr[0] += r[0];
                     totalArr[1] += r[1];
                     totalArr[2] += r[2];
                     tot += r[0] + r[1] + r[2];
                 });

                 let leftPieChartPercentageArray = [];
                 totalArr.map((r) => (r) / totalArr.reduce((a, v) => (a += v), 0));
                 var a = (totalArr[0] / tot) * 1;
                 leftPieChartPercentageArray.push(a);
                 a = (totalArr[1] / tot);
                 leftPieChartPercentageArray.push(a);
                 a = (totalArr[2] / tot);
                 leftPieChartPercentageArray.push(a);

                 if (totalArr[0] == 0 && totalArr[1] == 0 && totalArr[2] == 0) {

                     return;
                 }
                 leftPieChartPercentageArray = totalArr.map((r) => (r * 100) / totalArr.reduce((a, v) => (a += v), 0) / 100);

                 let val = [
                     new Proddata({
                         id: 0,
                         key: "productive",
                         val: leftPieChartPercentageArray[0] * 100,
                         val2: 0
                     })
                     ,
                     new Proddata({
                         id: 1,
                         key: "unproductive",
                         val: leftPieChartPercentageArray[1] * 100,
                         val2: 0
                     })
                     ,
                     new Proddata({
                         id: 2,
                         key: "Neutral",
                         val: leftPieChartPercentageArray[2] * 100,
                         val2: 0
                     })
                 ]

                 if (leftPieChartPercentageArray[0] != 0 || leftPieChartPercentageArray[1] != 0 || leftPieChartPercentageArray[2] != 0) {

                     this._timeandAttendanceServiceProxy.calculateProperPercentage(val).subscribe(res => {
                         this.meanProductivePercent = res[0].val;
                         this.meanUnproductivePercent = res[1].val;
                         this.meanNeutralPercent = res[2].val;
                     });
                 }
                 else {
                     this.meanProductivePercent = 0;
                     this.meanUnproductivePercent = 0;
                     this.meanNeutralPercent = 0;

                 }


             }
         }
         else {
             let totalPercentage = parseFloat(
                 (productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += (v.productivePercent + v.unproductivePercent + v.neutralPercent)), 0)).toFixed(1)
             );
             this.meanProductivePercent = parseFloat(
                 ((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += v.productivePercent), 0) * 100) / totalPercentage).toFixed(1)
             );
             if (isNaN(this.meanProductivePercent)) {
                 this.meanProductivePercent = 0;
             }
             this.meanUnproductivePercent = parseFloat(
                 ((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += v.unproductivePercent), 0) * 100) / totalPercentage).toFixed(1)
             );
             if (isNaN(this.meanUnproductivePercent)) {
                 this.meanUnproductivePercent = 0;
             }
             this.meanNeutralPercent = parseFloat(
                 ((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += v.neutralPercent), 0) * 100) / totalPercentage).toFixed(1)
             );
             if (isNaN(this.meanNeutralPercent)) {
                 this.meanNeutralPercent = 0;
             }

             let val = [
                 new Proddata({
                     id: 0,
                     key: "productive",
                     val: this.meanProductivePercent,
                     val2: 0
                 })
                 ,
                 new Proddata({
                     id: 1,
                     key: "unproductive",
                     val: this.meanUnproductivePercent,
                     val2: 0
                 })
                 ,
                 new Proddata({
                     id: 2,
                     key: "Neutral",
                     val: this.meanNeutralPercent,
                     val2: 0
                 })
             ]

             if (this.meanProductivePercent != 0 || this.meanUnproductivePercent != 0 || this.meanNeutralPercent != 0) {
                 this._timeandAttendanceServiceProxy.calculateProperPercentage(val).subscribe(res => {

                     this.meanProductivePercent = res[0].val;
                     this.meanUnproductivePercent = res[1].val;
                     this.meanNeutralPercent = res[2].val;
                     this.Fproductive = this.meanProductivePercent;
                     this.Funproductive = this.meanUnproductivePercent;
                     this.FNetural = this.meanNeutralPercent;

                 })
             }
         }
    }

    maxNum = 0;
    openSidebar(): void {
        this.isViewProductive = true;
        this.isViewUnProductive = false;
        this.isViewNeutral = false;
        this.isSidebarOpen = true;
        this.isOfflineTimeApproved= false;
        this.maxNum = this.sidebarSliderRangeValues[1];
    }

    // method to add productivity data from side panel
    tempStartTime = 9;
    addProductivityData(): void {
        this.isOfflineTimeSubmitted = true;
        if (this.checkIfManualTimeExist()) {
            this.message.error("Manual Time Exists")
            return;
        }
        if (!this.selectedTaskId || !this.sidebarProjectId || !this.productivityType || !this.descriptionOfAbsence) {
            return;
        }
        this.deleteManualTime(false);
        this.tempStartTime = Math.floor(this.sidebarSliderRangeValues[0] / 60);
        this.daySelectedSubscription = this._activityService.getMonthViewSelectedAsObs().subscribe((r) => {

            if (r.type === "day") {

                this.selectedDate = r.date;

                this.currentViewType = "day";

                if (this.selectedTaskId != undefined && this.sidebarProjectId != undefined) {

                    this._productivityBarService
                        .addManualEntry(
                            this.manualTimeIdToDelete,
                            this.sidebarSliderRangeValues,
                            this.descriptionOfAbsence,
                            this.sidebarProjectId,
                            this.selectedTaskId,
                            this.productivityType,
                            this.selectedDate,
                            this.SelectedTaskCategoryId
                        )
                        .subscribe(() => {
                            if (!this.TimeAddedForPreviousDay) {
                                this.OfflineTimeAdded.emit(this.tempStartTime);
                                // this.refreshProductivityBar();
                                // this.LoadBar();
                            }
                            else {
                                this.isSidebarOpen = false;
                                this.isOfflineTimeApproved = false;
                                this.manualTimeAdded.emit();
                                this.LoadBar();
                            }


                        });
                }

            }
        });

    }
    checkIfManualTimeExist() {
        let exist = false;
        let newManualTimeStart = this._productivityBarService.minutesToUTCDateTime(this.sidebarSliderRangeValues[0]);
        let newManualTimeEnd = this._productivityBarService.minutesToUTCDateTime(this.sidebarSliderRangeValues[1]);
        this.manualTime.forEach(manualTime => {
            if (this.manualTimeIdToDelete != manualTime.id && !(manualTime.startTime >= newManualTimeEnd || manualTime.endTime <= newManualTimeStart)) {
                exist = true;
            }
        })
        return exist;
    }

    setBlankDataForShimmer(): void {
        this.productivityData = this.timeSegmentArray.map((r) => {
            return new ProductivityCandle(false);
        });
    }

    clearAllTimeSegments(): void {
        const activeSegmentContainer = document.querySelectorAll(`.time-segment`);
        activeSegmentContainer.forEach((r) => {
            r.classList.remove("active-fill", "active-fill-manual-time", "active-fill-private-time-approved");
        });
    }
    clearMeanPercentage() {
        this.meanProductivePercent = 0;
        this.meanUnproductivePercent = 0;
        this.meanNeutralPercent = 0;
    }

    // monthly view
    // hide bottom blue container and get data for productivity candles
    // remove outline
    async setWeeklyData(): Promise<void> {
        const data = await this._productivityBarService.getDummyDateForWeeklyView(this.userId, this.tenantId, this.timeSegment, new Date() as any, new Date() as any, false).toPromise();
        this.weeklyData = {
            labels: data.map((r, i) => i.toString()),
            datasets: [
                {
                    label: "Productive",
                    data: data.map((r) => Math.floor(r.productive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.6,
                    backgroundColor: "#6FCEFB",
                },
                {
                    label: "Unroductive",
                    data: data.map((r) => Math.floor(r.unProdictive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.7,
                    backgroundColor: "#FF7D8B",
                },
                {
                    label: "Neutral",
                    data: data.map((r) => Math.floor(r.neutral)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.6,
                    backgroundColor: "#E4E4E4",
                },
            ],
        };
        this.currentViewType = "week";
    }

    async setMonthlyData(): Promise<void> {
        const data = await this._productivityBarService.getDummyDateForMonthlyView().toPromise();
        this.monthlyData = {
            labels: data.map((r, i) => i.toString()),
            datasets: [
                {
                    label: "Productive",
                    data: data.map((r) => Math.floor(r.productive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.3,
                    backgroundColor: "#6FCEFB",
                },
                {
                    label: "Unroductive",
                    data: data.map((r) => Math.floor(r.unProdictive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.3,
                    backgroundColor: "#FF7D8B",
                },
                {
                    label: "Neutral",
                    data: data.map((r) => Math.floor(r.neutral)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.3,
                    backgroundColor: "#E4E4E4",
                },
            ],
        };
        this.currentViewType = "month";
    }
    TimeAddedForPreviousDay = false;
    tempDelete = false;
    deleteManualTime(val: boolean): void {
        this.tempDelete = val;
        this.isSidebarOpen = false;
        this.isOfflineTimeApproved = false;
        this._productivityBarService.deleteManualTime(this.manualTimeIdToDelete).subscribe(() => {
            if (this.TimeAddedForPreviousDay || this.tempDelete) {
                this.OfflineTimeAdded.emit(this.tempStartTime);
                // this.refreshProductivityBar();
            }
            this.tempDelete = false;
            this.resetSidebar();
        });
    }

    setDataForEdit(manualEntryDto: ManualEntryDto): void {
        this.manualTimeIdToDelete = manualEntryDto.id;
        this.sidebarSliderRangeValues = [
            this._productivityBarService.jsDateToMinutesInTheDay(this._productivityBarService.getLocalJsDate(manualEntryDto.startTime)),
            this._productivityBarService.jsDateToMinutesInTheDay(this._productivityBarService.getLocalJsDate(manualEntryDto.endTime)),
        ];
        this.descriptionOfAbsence = manualEntryDto.description;
        this.sidebarProjectId = manualEntryDto.projectId;
        this.loadProjectWiseTasks([this.sidebarProjectId]);
        this.selectedTaskId = manualEntryDto.taskId;
        this.productivityType = manualEntryDto.productivityType;
        this.isOfflineTimeApproved = manualEntryDto.isApproved;
        if (this.productivityType == 1) {
            this.isViewProductive = true;
            this.isViewUnProductive = false;
            this.isViewNeutral = false;
        }
        if (this.productivityType == 2) {
            this.isViewProductive = false;
            this.isViewUnProductive = true;
            this.isViewNeutral = false;
        }
        if (this.productivityType == 3) {
            this.isViewProductive = false;
            this.isViewUnProductive = false;
            this.isViewNeutral = true;
        }
        this.cdRef.detectChanges();
    }

    // load all tasks for the filter based on project ids selected
    loadProjectWiseTasks(projectIds: number[]): void {
        this._projectTaskServiceProxy.getProjectWiseUserTaskList(projectIds, undefined, undefined, undefined, false, undefined).subscribe((projectTasks) => {
            this.taskList = projectTasks.reduce((a, v) => {
                return [...a, ...v.userTaskList];
            }, []);
        });
    }

    loadProjects(): void {
        this._projectServiceProxy.dropdownProjectList(abp.session.userId, abp.session.tenantId, true).subscribe((r) => {
            this.projectList = r;
        });
    }

    selectProject(project: DropdownProjectListDto): void {
        this.selectedTaskId = undefined;
        this.SelectedTaskCategoryId = undefined;
        if (project) {
            // this.loadProjectWiseTasks([project.id]);
            this.getTaskJobDetailsDayView(project.id);    
        } else {
            this.taskList = undefined;

        }
    }

    resetSidebar(): void {
        this.sidebarProjectId = undefined;
        this.selectedTaskId = undefined;
        this.currentTime = new Date();
        this.currTimeMins = this.currentTime.getHours() * 60 + this.currentTime.getMinutes();
        //  this.TimeAddedForPreviousDay=false;
        this.sidebarSliderRangeValues = [0, this.currTimeTotMins()];
        this.productivityType = undefined;
        this.descriptionOfAbsence = undefined;
        this.manualTimeIdToDelete = undefined;
    }

    isDataEmpty() {
        return _.every(this.productivityData, (r) => !r?.isDataAvailable);
    }

    ngOnDestroy(): void {
        this.daySelectedSubscription?.unsubscribe();
        this.productivityData = undefined;
        // This aborts all HTTP requests.
        this.ngUnsubscribe.next();
        // This completes the subject properlly.
        this.ngUnsubscribe.complete();
    }

    // for lengthy long name tooltip hide or show condition
    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    resetSidePanelErrors() {
        this.isOfflineTimeSubmitted = false;
    }
    closeSidePanel() {
        this.isViewProductive = true;
        this.isViewUnProductive = false;
        this.isViewNeutral = false;
        this.resetSidePanelErrors();
        this.isSidebarOpen = false;
        this.isOfflineTimeApproved = false;
    }


    getTaskJobDetailsDayView(projectId: number) {
        this._projectTaskServiceProxy.getJobTaskDetails(projectId).subscribe((jobDetails: any[]) => {
            this.taskDetails = jobDetails.filter(x => x.jobName);
            // this.jobs = this._tus.getUniqueArrayForJobs(this.taskDetails);
            this.jobs = [...new Map(this.taskDetails.map(item => { return [item.taskJobId, { id: item.taskJobId, name: item.jobName, projectId: item.projectId, isDeleted: item.isDeleted }]; })).values()].sort((a, b) => a.name.localeCompare(b.name));
            // this.jobs = Array.from(new Set(this.taskDetails.map((item) => { return {id : item.taskJobId, name: item.jobName} })));
        });
    }

    onJobChange(selectedJob: any) {
        if (selectedJob !== undefined && selectedJob !== null) {

            this.selectedTaskId = undefined;
            this.taskMenu = this.taskDetails
                .filter((item) => item.taskJobId === selectedJob?.id &&  (selectedJob.projectId === null || item.projectId === selectedJob.projectId ) && !item?.isDeleted)
                .map((item) => { return { id: item.taskId, name: item.masterTaskName, projectId: item.projectId } }).sort((a, b) => a.name.localeCompare(b.name));
            // this.taskMenu = this.taskMenu.filter(x => !this.inputPassForDayView.find(y => x.id == y.userTaskId && !y['isProject']) && x.projectId == this.inputManualAddTimesheet?.projectId || x.projectId == null);
        }
    }
}
